import React from 'react';

export const ErrorBoundaryFallback = ({ language }) => {
  function getFromTranslation(key, fallback) {
    return key in language ? language[key] : fallback;
  }

  function getEmailSubject() {
    return `${getFromTranslation('leazard-error-boundary-email-subject', 'Leazard error')} [${window.location.host}]`;
  }

  return (
    <div className="leazard">
      <div className="leazard-header">
        <p>{getFromTranslation('leazard-error-boundary-headline', 'Something went wrong')}</p>
        <span>
          {getFromTranslation('leazard-error-boundary-description', 'Please click the button below to try again.')}
          <a style={{ fontSize: 14, color: '#fff', fontWeight: 600 }} href={`mailto:hei@nettbureau.no?subject=${getEmailSubject()}`}>
            {getFromTranslation('leazard-error-boundary-contact-customer-service', 'customer service')}
          </a>
        </span>
        <div className="leazard-cta">
          <button onClick={() => window.location.reload()} style={{ padding: 10, marginTop: 20 }} className="leazard-info-btn">
            {getFromTranslation('leazard-error-boundary-button-text', 'Try again')}
          </button>
        </div>
      </div>
    </div>
  );
};
